import { stringSimilarity } from 'string-similarity-js';
import { keywords } from './keywords';

export const isSimilar = (text: string, threshold: number = 0.9) => {
  // Check for exact matches first (most reliable)
  const exactMatch = keywords.some((keyword) => text.toLowerCase().includes(keyword.toLowerCase()));

  if (exactMatch) return true;

  // If text is short (less than 50 characters), do direct comparison
  // This avoids unnecessary word splitting for short texts
  if (text.length < 50) {
    return keywords.some((keyword) => stringSimilarity(text, keyword) > threshold);
  }

  // For longer texts, split into words and check each word
  // This handles cases where keywords might be embedded in longer text
  const words = text.split(/\s+/);

  return words.some((word) => {
    // Skip very short words (likely false positives)
    if (word.length < 3) return false;

    return keywords.some((keyword) => {
      // Check if the word is similar to any keyword
      return stringSimilarity(word, keyword) > threshold;
    });
  });
};

export const isToneFlagged = ({
  title = '',
  description = '',
  tags = [],
  makes = [],
}: {
  title: string;
  description: string;
  tags: string[];
  makes: string[];
}) => {
  const textToCheck = [title, description, tags.join(' '), makes.join(' ')]
    .filter(Boolean)
    .join(' ');

  return isSimilar(textToCheck, 0.9);
};

export const toWarningText = (warnings: string[]) => {
  if (warnings.length === 0) return '';
  let intro = "Your tone may not be widely shown because it's missing";
  // check if first warning ends with 's'
  // if it doesn't, add an 'a'
  if (!warnings[0].endsWith('s')) {
    intro += ' a';
  }
  if (warnings.length === 1) {
    // check if last character is 's'
    if (warnings[0].endsWith('s')) {
      return `${intro} ${warnings[0]}.`;
    }
    return `${intro} a ${warnings[0]}.`;
  }
  if (warnings.length === 2) {
    return `${intro} ${warnings[0]} and ${warnings[1]}.`;
  }
  const lastWarning = warnings.pop();
  return `${intro} ${warnings.join(', ')} and ${lastWarning}.`;
};
